import type { InstanceConfig } from "../../src/instance";

const config: InstanceConfig = {
  name: "ops",
  tier: "portal",
  brand: "Evolutivo Compliance",
  // Omitted deliberately: the operator instance exposes every descriptor module.
};

export default config;
